import Vue from 'vue'
import router from './router'
import store from './store'
import utilsAuth from '@/utils/auth'

const routerWhitelist = ['/signin', '/signup', '/agreement', '/forget'];

router.beforeEach((to, from, next) => {
	if (utilsAuth.getAccessToken()) {
		if (to.path === '/signin') {
			next({ path: '/' })
		} else {
			if (!store.getters.roles.length) {
				store.dispatch('GetShopInfo').then(data => {
					// 根据权限获取路由
					store.dispatch('GenerateRoutes', data).then(data => {
						router.addRoutes(store.getters.addRouters)
                        if (!store.getters.shopList.length) {
                            store.dispatch('GetShopList')
                        }
						next({ ...to, replace: true })
					})
				}).catch(() => {
					// 登出
					store.dispatch('LogOut').then(() => {
						Vue.prototype.$Message.warning({
							content: '登录失效，请重新登录', 
                            onClose: () => {
                            	next({ path: '/login' })
                            }
                        })
					})
				})
			} else {
				if (to.name && to.name.indexOf('Popup') === 0) {
					Vue.prototype.$Popup.open(to.meta.component, to.params, to.query)
					next(false)
				} else {
					next()
				}
			}
		}
	} else {
		if (routerWhitelist.indexOf(to.path) !== -1) {
			next()
		} else {
            let ref = '';
            ref = encodeURIComponent(to.fullPath)
			next('/signin?referer=' + ref)
		}
	}
})



// WEBPACK FOOTER //
// ./src/permission.js